import React,{useEffect, useState} from "react"
import { useParams } from "react-router-dom"

import { Row, Col, Card, CardBody, CardTitle, InputGroup, Label, Form, FormGroup, Button, Modal, Pagination, PaginationItem, PaginationLink } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import { connect } from "react-redux";
import * as url from "../../helpers/url_helper"
import { setBreadcrumbItems } from "../../store/actions";
import moment from "moment"
import { RingLoader } from "react-spinners";
import { BarLoader } from "react-spinners";

const DailyDetail = (props) => {
  document.title = "Planning | Interface de plannification des agents";
  const { id } = useParams();
  const breadcrumbItems = [
    { title: "ueDigital", link: "/dashboard" },
    { title: "Rapports", link: "#" },
    { title: "Planning des agens", link: "#" },
  ]
  const [loadingPlanning, setLoadingPlanning] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [value, setValue] = useState('');
  const [selectedUser, setSelectedUser] = useState([]);
  const [selectedOption, setSelectedOption] = useState();
  const [details, setdetails] = useState([]);
  const [plannings, setPlannings] = useState([]);
  const [totalPlannings, setTotalPlannings] = useState(0);
  const [agTransit, setAgTransit] = useState(null);
  const [heure, setHeure] = useState(moment().format("YYYY-MM-DD HH:mm"));
  const [selectedAgTransit, setSelectedAgTransit] = useState(null);
  const handleAgTransit= (event)=>{ setSelectedAgTransit(event); setAgTransit(event.value); }
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const option= [ { options: [
    {value: "Colis veille expédiés", label: "Colis veille expédiés"},
    {value: "Colis veille arrivés", label: "Colis veille arrivés"},
    {value: "Colis jour expédiés", label: "Colis jour expédiés"},
    {value: "Colis jour arrivés", label: "Colis jour arrivés"}
  ] } ]
  const [modal_opera, setmodal_opera] = useState(false)
  const [modal_lock, setmodal_lock] = useState(false)
  const [modal_send, setmodal_send] = useState(false)
  let [loading, setLoading] = useState(false);
  let [lockLoading, setLockLoading] = useState(false);
  const [msgError, setMsgError]= useState("");
  const [msgSuccess, setMsgSuccess]= useState("");
  const handleStartDate= (date)=>{ setStartDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleEndDate= (date)=>{ setEndDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleSendDate= (date)=>{ setHeure(moment(date[0]).format("DD-MM-YYYY HH:mm")); }
  const handleDestination= (event)=>{ setSelectedUser(event); }
  const handleOption= (event)=>{ setSelectedOption(event); console.log(event);
   }
  const userJson= JSON.parse(localStorage.getItem("user"));

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  function tog_get_opera() {
    setmodal_opera(!modal_opera)
    removeBodyCss()
  }
  function tog_lock_bord() {
    setmodal_lock(!modal_lock)
    removeBodyCss()
  }
  function tog_send_bord() {
    setmodal_send(!modal_send)
    removeBodyCss()
  }
  const loadDetail=(page)=> {
    setLoadingPlanning(true)
    fetch(`${url.BACKEND_URL}/report-detail?reportId=${id}`, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { console.log(responseJson.data);
      if (responseJson.status==200) { 
        setPlannings(responseJson.data)
        setTotalPlannings(responseJson.totalElement)
        setTotalPage(responseJson.totalPage)
        setCurrPage(responseJson.current_page)
        setLoadingPlanning(false)
    } else {  setLoadingPlanning(false) }
    }) .catch((error) => { setLoadingPlanning(false) });
  };
  
  const verifData= ()=>{
    if (selectedOption==null) { setMsgError("Veuillez entrer le label svp"); return false;}
    else if (value.trim()==="") { setMsgError("Veuillez entrer la valeur"); return false;}
    else {return true; }
  }

  const saveDetail=()=>{
    if (verifData()) {
      const data=JSON.stringify(
          {
            report: {id: id},
            label: selectedOption.value,
            value: value
          });
          console.log(data);
          
      fetch(`${url.BACKEND_URL}/report-detail`, { method: 'POST', headers: {'Content-Type': 'application/json' },
        body: data })
      .then((response) => response.json())
      .then((responseJson) => { console.log(responseJson.data);
        if (responseJson.status==200) { 
          loadDetail();
          setMsgSuccess(responseJson.message)
          setValue("")
          loadDetail(0)
          setTimeout(() => { tog_get_opera(); }, 500); 
      } else {  }
      }) .catch((error) => {  });
    }
    
  }

  useEffect(() => {
    props.setBreadcrumbItems('Bordereaux', breadcrumbItems)
    loadDetail(0)
  }, [])

  const getOperation=(item)=> {
    return (
        <Row>
          <Col xl="12">
            <div className="table-rep-plugin">
              <div className="table-responsive mb-0" data-pattern="priority-columns">
              <Table id="tech-companies-1" className="table table-striped table-bordered">
              <Tbody>
                      {details.map((item, key)=>(
                      <Tr>
                        <Th>
                          <strong>{item.label}</strong>
                        </Th>
                        <Td style={{ fontSize: 9 }}><strong>{item.users?.map(u => u.usNom).join(", ")}</strong></Td>
                      </Tr>
                      ))}
                    </Tbody>
              </Table>
              </div>
            </div>
          </Col>
        </Row>);
      };

  return (
    <React.Fragment>
      
      <Modal size="l" isOpen={modal_opera} toggle={() => { tog_get_opera() }}>
        <div className="modal-header bg-primary text-white">
          <h2 className="modal-title mt-0" id="myLargeModalLabel">Détail du rapport</h2>
          <button onClick={() => {setmodal_send(false) }} type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" style={{ color: "black" }}>x</span>
          </button>
        </div>
        <div className="modal-body">
          <Col xl="12">
            <FormGroup className="mb-4">
              <Select value={selectedOption} onChange={handleOption} options={option} classNamePrefix="select2-selection"/>
            </FormGroup>
          </Col>
          <Col xl="12">
            <FormGroup className="mb-4">
              <div className="mb-3">
                <label className="form-label" htmlFor="formrow-firstname-input" style={{fontSize: 18}}>Valeur</label>
                <input type="number" value={value} style={{fontSize: 22}}  onChange={(event)=>setValue(event.target.value)} className="form-control" id="exp" placeholder="Valeur"/>
              </div>
            </FormGroup>
          </Col>
          <Col xl="12">
            <Button className="btn btn-lg btn-primary" style={{ width: "100%" }} tag="button" onClick={() => {saveDetail()}}>
              ENREGISTRER
            </Button>
          </Col>
          <Col xl="12">
            <strong className="text-danger" style={{ width: "100%" }}>{msgError}</strong>
          </Col>
        </div>
        
      </Modal>
      <Row className="mb-4">
        <Col xl="4">
          <Button className="btn btn-lg btn-info" tag="button" data-toggle="modal" data-target=".bs-example-modal-lg" onClick={() => {tog_get_opera()}}>
            AJOUTER LES DETAILS
          </Button>
        </Col>
      </Row>
      <Row>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Début</Label>
            <InputGroup>
              
              <Flatpickr
                className="form-control d-block"
                placeholder="Date début"
                value={startDate}
                onChange={handleStartDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Fin</Label>
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Date Fin"
                value={endDate}
                onChange={handleEndDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        
        <Col lg="3">
          <div className="mt-3">
            <Button type="button" style={{ width: "100%" }} onClick={()=>{loadDetail(0)}} color="primary" data-toggle="Button" size="lg" className="mt-2 waves-effect waves-light">Rechargé</Button>
          </div>
        </Col>
      </Row>
     <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="h4">{totalPlannings} élément(s) </CardTitle>
              <Card>
                {totalPage ==0 ? ( null): totalPage>=25 ? (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: 25}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadDetail(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadDetail(totalPage-1)}>......{totalPage-1}</PaginationLink></PaginationItem>
                      <PaginationItem><PaginationLink onClick={()=>loadDetail(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>): (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: totalPage}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadDetail(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadDetail(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>)}
              </Card>

              <div className="table-rep-plugin">
                <div
                  className="table-responsive mb-0"
                  data-pattern="priority-columns"
                >
                  <div>
                    {loadingPlanning ? (<BarLoader width={"100%"} height={6}/>): null}
                  </div>
                  <Table
                    id="tech-companies-1"
                    className="table table-striped table-bordered"
                  >
                    <Thead>
                      <Tr>
                        <Th data-priority="1">Libellé</Th>
                        <Th data-priority="3">Valeur</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {plannings.map((item, key)=>(
                      <Tr>
                        <Td>{item.label}</Td>
                        <Td>{item.value}</Td>
                      </Tr>
                      ))}
                      
                    </Tbody>
                  </Table>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}
export default connect(null, { setBreadcrumbItems })(DailyDetail);